"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzTextarea__Wrapper",
  componentId: "sc-109h089-0"
})(["\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "OzTextarea__Container",
  componentId: "sc-109h089-1"
})(["\n  position: relative;\n  display: block;\n  width: ", ";\n  max-width: 100%;\n  display: flex;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.width;
});

var Input = _styledComponents.default.textarea.withConfig({
  displayName: "OzTextarea__Input",
  componentId: "sc-109h089-2"
})(["\n  font-family: 'Be Vietnam Pro', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n\n  resize: none;\n  padding: 8px 10px;\n  min-height: 40px;\n  letter-spacing: inherit;\n  outline: none;\n  box-sizing: border-box;\n  width: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n\n  border-radius: 4px;\n\n\n  ", ";\n"], function (props) {
  return props.variant === "default" ? "\n    background-color: " + (props.disabled ? "#F2F4FD" : "#ffffff") + ";\n    color: " + (props.disabled ? "#30303054" : _consts.BLACKPEARL) + ";\n    border: 1px solid " + (props.highlighted ? _consts.CHETWODEBLUE : _consts.BORDER) + ";\n    box-shadow: inset 0px 1px 2px #687FE262;\n\n    ::placeholder {\n      color: #dedede;\n      opacity: 1;\n    }\n\n    :-webkit-autofill {\n      ".concat(function (props) {
    return props.disabled ? "\n        box-shadow: inset 0 0 0px 9999px #F2F4FD;\n      " : "\n        box-shadow: inset 0 0 0px 9999px #ffffff;\n      ";
  }, ";\n    }\n  ") : props.variant === "charcoal" ? "\n      background-color: " + (props.disabled ? "#F2F4FD" : "#455262") + ";\n      color: " + (props.disabled ? "#30303054" : "#FFFFFF") + ";\n      border: 1px solid " + (props.highlighted ? _consts.CHETWODEBLUE : _consts.BLACKPEARL) + ";\n      box-shadow: inset 0px 1px 2px #20283362;\n\n      ::placeholder {\n        color: #FFFFFF;\n        opacity: 1;\n      }\n\n      :-webkit-autofill {\n        ".concat(function (props) {
    return props.disabled ? "\n          box-shadow: inset 0 0 0px 9999px #F2F4FD;\n        " : "\n          box-shadow: inset 0 0 0px 9999px #ffffff;\n        ";
  }, ";\n      }\n  ") : null;
});

var Label = _styledComponents.default.div.withConfig({
  displayName: "OzTextarea__Label",
  componentId: "sc-109h089-3"
})(["\n  margin-top: 20px;\n  margin-bottom: 5px;\n  font-size: 11px;\n  font-weight: 300;\n"]);

var OzTextarea = function OzTextarea(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      label = _ref.label,
      placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 4 : _ref$rows,
      _onChange = _ref.onChange,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "260px" : _ref$width,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$highlighted = _ref.highlighted,
      highlighted = _ref$highlighted === void 0 ? false : _ref$highlighted,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return __jsx(Wrapper, null, label ? __jsx(Label, null, label, " ", required ? "*" : "") : null, __jsx(Container, {
    width: width
  }, __jsx(Input, {
    placeholder: placeholder,
    variant: variant,
    rows: rows,
    disabled: disabled,
    highlighted: highlighted,
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e.target.value);
      }

      ;
    },
    value: value,
    required: required
  })));
};

var _default = OzTextarea;
exports.default = _default;